import React, { useState } from 'react';
import Loader from './common/Loader';
import { useFetchStaticData } from './data/fetchStaticData';
import { getBetradarStreamingProps } from './data/streaming/streamingUtils';
import { unmappedMarkets } from './data/unmapped-markets';
import { getConfiguration } from './data/utils/configuration';
import { getCookie } from './data/utils/getCookie';
import { loadLanguage } from './data/utils/loadLanguage';
import { getEnv } from './data/env';
import { appConfig } from './appConfig.js';
import { systemCode } from '.';
import { getQueryStringVariable } from './data/utils/getQueryStringVariable.js';
// import { localhostInterceptor } from './data/service-workers/localhost-interceptor';

function loadXSportDatastoreStaticResources() {
    const conf = getConfiguration();
    const version = conf['ver'];
	//const hrefMobileCSS =  conf['hfmnew'] || conf['hfm'];
	const hrefMobileCSS = conf['hfmnew'];
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${hrefMobileCSS}?xsdv=${version}`;

    document.head.append(link);
    
    //CSS dark mode
    const isDarkModeCookieSet = getCookie('cg-dark-mode') === 'true'  || getQueryStringVariable('cg-dark-mode') == 'true';
    if (hrefMobileCSS && ((appConfig?.['THEME'] && appConfig['THEME']?.['enabled']) || isDarkModeCookieSet)) {
        const linkDark = document.createElement('link');
        linkDark.id = "xsp_css_dark";
        linkDark.class = "xsp cg-dark-cssfile";
        linkDark.rel = 'stylesheet';
        const isDark = appConfig['THEME']?.['dark'] || isDarkModeCookieSet;

        if (!isDark) {
            linkDark.disabled = "disabled";
        }
        const indexOf = hrefMobileCSS.indexOf(".css");
        if (indexOf > 1) {
            linkDark.href = `${hrefMobileCSS.substring(0, indexOf)}_dark${hrefMobileCSS.substring(indexOf)}?xsdv=${version}`;
            document.head.append(linkDark);
        }
    }
}

function loadScriptsFromDataConfig() {
    const apiDomain = getEnv('REACT_APP_API_DOMAIN');
    const warName = getEnv('REACT_APP_WAR_NAME') ? getEnv('REACT_APP_WAR_NAME') : 'XSportDatastore';
    const xs_languageCode = loadLanguage();
    const scriptUrls = [];
    const cssHrefs = []
    const configuration = getConfiguration();
    try {
        let widgetURL = configuration.ps.lte['BETRADAR_WIDGET']?.['ujs']?.['ALL'] ?? null;
        if (widgetURL!= null) {
            widgetURL = widgetURL.replace('{{lang}}', xs_languageCode.toLowerCase());
            scriptUrls.push(widgetURL);
        }
        const streamingRadar = getBetradarStreamingProps();
        if (streamingRadar) {
            //scriptUrls.push(`${apiDomain}/${warName}/content/js/streaming/avvpl-player.js`);
            //cssHrefs.push(`${apiDomain}/${warName}/content/js/streaming/style/styles.css`);
            scriptUrls.push(`https://avplayer-cdn.akamaized.net/dist/latest/avvpl-player.js`);
            cssHrefs.push(`https://avplayer-cdn.akamaized.net/dist/latest/styles.css`);
        }
    } catch(err) {
      console.log(err);
    }
    // TODO scarica solo se necessario
    scriptUrls.push(`${apiDomain}/${warName}/content/js/lib/barcode/JsBarcode.all.min.js`);
  
    cssHrefs.forEach(function(h) {
        var lnk = document.querySelectorAll(`link[href="${h}"]`);
        if (!lnk.length) {
            var css = document.createElement('link');
            css.setAttribute("rel", "stylesheet")
            css.setAttribute('href', h);
            document.head.appendChild(css);
        }
    });
    if(configuration.bbc?.en){
    	// configurazione bet builder scaricata come file js
    	const warName = getEnv('REACT_APP_WAR_NAME')? getEnv('REACT_APP_WAR_NAME') : 'XSportDatastore';
    	const betBuilderConfScript = `${getEnv('REACT_APP_API_DOMAIN')}/${warName}/static-object-js/${systemCode}/${xs_languageCode}/betBuilderConfiguration.js?v=${new Date().getTime()}`;
    	scriptUrls.push(betBuilderConfScript);
    } 
    scriptUrls.forEach(function(s) {
        var scr = document.querySelectorAll(`script[src="${s}"]`);
        if (!scr.length) {
            var script = document.createElement('script');
            script.setAttribute('src', s);
            document.head.appendChild(script);
        }
    });
}

function InitData(props) {
    const [onInitState,setOnInitState] = useState(false);

    if (window.xs_ag === undefined) {
        window.xs_ag = {
            betById: {},
            aggregatePrematchBySportId: {},
            aggregateLiveByIdSport: {},
            agsByBetId: {},
            agsByBetIdAndSportId: {}
        };
    }
    const [state] = useFetchStaticData();

    if (state.isLoading) {
        return null;
    } else if (state.isError) {
        return <Loader error={state.isError} centered={true} />;
    }

    if (!onInitState) {
        // localhostInterceptor();
        loadXSportDatastoreStaticResources();
        loadScriptsFromDataConfig();

        unmappedMarkets.fetch();
        setOnInitState(true);
    }

    return (
        <>
            {props.children}
        </>
    );
}

export default InitData;
